import { Component, OnInit } from '@angular/core';
import { DateService } from '../services/date.service';
import { GeneralService } from '../services/general.service';
import {  Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ActionsService } from '../services/actions.service';
@Component({
  selector: 'app-planning-client',
  templateUrl: './planning-client.component.html',
  styleUrls: ['./planning-client.component.scss']
})
export class PlanningClientComponent implements OnInit
{
  constructor(public actionsService : ActionsService,public route: ActivatedRoute,public generalService: GeneralService,public dateServise : DateService,public router:Router ) { }
  
  urlClient = this.generalService.urlSelectClient;
  listeClients;
  listeColl;
  listWeek;
  listMonth;
  listYear;
  date_Debut;
  date_Fin;
  client :string;
  disabled;
  listeActionD;
  showCalendar = false;
  events=[];
  expanded = true;
  intervale;
  defaultDate;
  date;
  ngOnInit() 
  {    
    this.readParamUrl();
  }
  init()
  {
    this.generalService.rechercheTable(this.urlClient).subscribe(data => 
    {
      this.listeClients = this.generalService.sort(data.filter(cli =>{return cli.Tiers_Type!="2"}),"Tiers_NomPublic");
      this.date_Debut = new Date();
      this.date_Debut.setMonth(this.date_Debut.getMonth()-2);
      this.date_Debut.setDate(1);
      this.date_Fin = new Date();
      this.date_Fin.setMonth(this.date_Fin.getMonth()+2);
      this.date_Fin.setDate(1);
      if(this.date != "1" && this.intervale != "1")
      {
        this.afficherDate();
        this.showDetaille( this.date,  this.intervale);
      }
    });    
  }
  async afficherDate()
  {
    if(this.client  != undefined)
    {
      this.listeActionD = await this.generalService.rechercheTable(this.generalService.urlListeActionActionDClient+this.dateServise.setFormatDateRechercheServer(this.date_Debut)+","+this.dateServise.setFormatDateRechercheServer(this.date_Fin)+","+this.client).toPromise();
      this.listWeek = this.dateServise.getListWeek(this.date_Debut,this.date_Fin);
      this.listMonth = this.dateServise.getListMonth(this.date_Debut,this.date_Fin,0);
      this.actionsService.enableDesableBouton(this.listWeek,this.listMonth,this.listeActionD);
    }
    else
      this.generalService.dialogSuccess("veuillez choisir un client",false)
    

  }
  async showDetaille(date, intervale)
  {
    if(this.date_Debut != null && this.date_Fin != null &&  this.date_Debut<this.date_Fin && this.client != undefined)
    {
      this.showCalendar = false;
      this.defaultDate = this.dateServise.convertStrToDate(date);
      this.events = [];
      this.intervale = intervale;      
      this.listeActionD = await this.generalService.rechercheTable(this.generalService.urlListeActionActionDClient+this.dateServise.setFormatDateRechercheServer(this.date_Debut)+","+this.dateServise.setFormatDateRechercheServer(this.date_Fin)+","+this.client).toPromise();
      if(this.listeActionD.length >0)
      {
        //********* ajouter le filtrage date debut et fin  */ 
        //var listeCodeAction = this.listeAction.map(action => action.avtAction_Code).reduce((accumulator, currentValue) => accumulator+";" + currentValue);
        this.listeColl = await this.generalService.rechercheTable(this.generalService.urlListPerso).toPromise();
        this.events = this.actionsService.setCalendar2(this.listeActionD,this.events,this.listeClients,this.listeColl,"client");        
        this.showCalendar = true;
      }
      else
      {
        this.generalService.dialogSuccess("Aucune action à afficher",false)
      }
      
    }
    else
    {
      this.generalService.dialogSuccess("veuillez SVP remplir le formulaire ci-dessous",false)
    }
  }
  
  eventRender(event)
  {
    event.event.el.querySelector('.fc-title').innerHTML = event.event.event.title;
  }
  actionCalendar(event)
  {
    switch (event.acton)
    {
      case "eventRender":
          this.eventRender(event);
      break;
    }
    
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      if(params['param_code'] != "-1")
        this.client = params['param_code']; 
      this.date = params['date'];
      this.intervale = params['intervale'];
      this.init();
    });
  }
}
